export const Constants = {
  SYSTEM: {
    DEFAULT_TITLE: 'Cleveland',
    DEFAULT_ICON: 'https://social-cfd-test.sworks.io/sworksio/assets/ca5a7df3640bcce84585c3d1ab2802fc.png',
    DEFAULT_BANNER: 'https://social-cfd-test.sworks.io/sworksio/assets/0541015af1ee5bd1f21a0cf973457a55.png',
    DEFAULT_THEME: {
      '--bg-primary': '#ffffff',
      '--bg-secondary': '#f8f9fa',
      '--primary': '#f8f9fa',
      '--text-alternate': '#6c757d',
      '--text-primary': '#212529',
      '--text-secondary': '#495057',
    },
    DEFAULT_LOADER: {
      TYPE: 'Puff',
      COLOR: '#00BFFF',
      BACKGROUND: '#00BFFF',
    },
    VALUE_DEFAULT_RESPONSE_TYPE: 'json',
    COPYRIGHT_FOOTER: `Copyright © ${new Date().getFullYear()} Cleveland. All rights reserved`,
    WEBSITE_LINK: 'https://www.cleveland.com',
  },
  FIELD: {
    AUTH_TOKEN: 'authToken',
    USER: 'user',
    IS_AUTHENTICATED: 'isAuthenticated',
    CONFIGURATIONS: 'configurations',
    DASHBOARD_CONFIGURATIONS: 'dashboard_configurations',
    REFETCH_ON: 'refetchOn',
    SELECTED_MENU: 'selectedMenu',
    PUSH_NOTIFICATION_TOKEN: 'pushNotificationToken',
  },
};

export default Constants;
